<div class="flex column">
  <span class="overlay-title">{{ overlayData().title }}</span>
  <span class="overlay-subtitle">{{ overlayData().subtitle }}</span>
  @if (overlayData().audits?.length) {
    <tiime-timeline>
      @for (audit of overlayData().audits; track audit.uuid) {
        <tiime-timeline-item [color]="audit.value | statusColor: overlayData().statusType">
          <div tiimeTimelineItemDate>
            {{ audit.recordedAt | date: 'dd/MM/YYYY' }}
            <br />
            à {{ audit.recordedAt | date: 'HH:mm' }}
          </div>
          <div tiimeTimelineItemTitle>{{ audit.value | statusLabel: overlayData().statusType }}</div>
          <div tiimeTimelineItemDescription [tiimeTooltip]="audit | timelineItemDescription" tooltipHideWithoutEllipsis>
            <span>{{ audit | timelineItemDescription }}</span>
          </div>
        </tiime-timeline-item>
      }
    </tiime-timeline>
    <button class="see-history-button" tiime-button color="primary" (click)="openHistoryDialog()">
      Voir tout l'historique
    </button>
  }
  <tiime-alert primary>
    Le suivi de l'historique
    <span class="bold">n'est pas en temps réel</span>
    et
    <span class="bold">peut être inexistant pour des changements trop anciens.</span>
    <br />
    Veuillez revenir ultérieurement si vous avez effectué des changements récents.
  </tiime-alert>
</div>
